
import { createContext } from '@fluentui/react-context-selector';

import { AppContext } from './interfaces';

const storeContext = createContext<AppContext>({
    appState: undefined,
    dispatch: () => ({})
});

export default storeContext;